import { useQuery } from "@tanstack/react-query";
import OCGatewayClient from "../client/OCGatewayClient";
import { EventSummaryLocalisedDescription } from "../models/EventSummary";

export function useEventSummaryKeyLocalisedDescriptionQuery(summaryKey?: string | null, locale?: string | null) {
    return useQuery({
        queryKey: ['getEventSummaryKeyLocalisedDescription', summaryKey, locale].filter(Boolean),
        enabled: !!summaryKey && !!locale,
        queryFn: async (): Promise<EventSummaryLocalisedDescription | null> => {
            if (!summaryKey || !locale) {
                return null;
            }

            return OCGatewayClient.request('getEventSummaryKeyLocalisedDescription', {
                summaryKey,
                locale
            }) as Promise<EventSummaryLocalisedDescription | null>;
        },
        staleTime: Infinity,
        gcTime: 1000 * 60 * 60 * 24,
        networkMode: 'always',
        retry: false
    });
}
